'use client';

import { useTrackingCookies } from '@/hooks/useTrackingCookies';

export default function TrackingCookieHandler() {
  useTrackingCookies();
  return null;
}
